<template>
    <div>
        <div :class="[{'lesson-blocked': isOrderLockedAlert || isPerDayLockedAlert || isPerPartialPayLockedAlert || isSubscriptionExpiredLocked || restrictedToFreeSubscriptionAlert || restrictedByPartialPayDebt}]">
            <div v-if="course" class="container-fluid lessons-list d-xl-block d-none pl-0 pr-0">
                <div class="row no-gutters">
                    <div class="col"
                         v-for="lesson in course.lessons"
                         :key="lesson.id">
                        <lesson-nav-item :lesson="lesson" :color="getColor(lesson)"></lesson-nav-item>
                    </div>
                </div>
            </div>

            <div class="container-fluid lessons-tabs">
                <div class="container">
                    <div class="row justify-content-center lessons-tabs-row">
                        <div class="col-xl-2 col-12 order-lg-8 order-1 text-xl-right text-center ml-xl-auto top-select-lesson-wrapper px-lg-0"
                             v-if="lessons">
                            <base-dropdown class="nav-item top-select-lesson  pt-1 pb-1 text-right" position="right">
                                <a slot="title" class="nav-link pt-xl-2 pt-1 pb-1" href="javascript:void(0);"
                                   role="button">
                                    <i class="fa fa-chevron-down mr-2"></i>
                                    <span class="nav-link-inner--text">{{ $t('lessons_list') }}</span>
                                </a>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0"><i class="fa fa-chevron-up mr-1"></i> {{ $t('lessons_list') }}
                                    </h6>
                                </div>
                                <div class="dropdown-divider mt-0 mb-0"></div>
                                <router-link :to="`/course/${course.slug}`" class="dropdown-item" v-if="!isAndroidApp()">
                                    <span class="nav-link-inner--text">{{ $t('all_course_lessons') }}</span>
                                </router-link>
                                <div class="dropdown-divider mt-0 mb-0"></div>
                                <router-link v-for="item in lessons"
                                             :key="item.idlesson"
                                             :to="`/lesson/${item.idlesson}`" class="dropdown-item">
                                    <span class="nav-link-inner--text">{{item.lesson}}</span>
                                </router-link>
                            </base-dropdown>
                        </div>
                        <div class="col-xl-2 mr-auto order-lg-1 order-2"></div>
                        <div class="col-auto order-lg-2 order-3" v-for="(video, index) in videos"
                             :key="video.idelement">
                            <base-button
                                    @click="currentTabIndex = video.idelement"
                                    :class="['pr-2', {'active': currentTabIndex === video.idelement}]">
                                <span class="dashed-text" v-if="videos.length === 1">{{ $t('lesson') }}</span>
                                <span class="dashed-text" v-else>{{ $t('lesson') }} {{ index + 1}}</span>
                                <a v-if="!isAndroidApp()" class="external-link ml-2" @click.stop
                                   :href="`${publicPath}lesson/${id}/tab/${video.idelement}`"
                                   target="_blank">
                                    <i class="fa fa-external-link-alt" :title="$t('open_in_new_tab')"></i>
                                </a>
                            </base-button>
                        </div>
                        <div class="col-auto order-lg-3 order-4" v-if="tests.length > 0">
                            <base-button
                                    @click="currentTabIndex = testTabIndex"
                                    :class="['pr-2', {'active': currentTabIndex === testTabIndex}]">
                                <span class="dashed-text">{{ $t('simulators') }}</span>
                                <a v-if="!isAndroidApp()" class="external-link ml-2" @click.stop
                                   :href="`${publicPath}lesson/${id}/tab/${testTabIndex}`"
                                   target="_blank">
                                    <i class="fa fa-external-link-alt" :title="$t('open_in_new_tab')"></i>
                                </a>
                            </base-button>
                        </div>
                        <div class="col-auto order-lg-4 order-5" v-if="vocabularies.length > 0">
                            <base-button
                                    @click="currentTabIndex = vocabularies[0].idelement"
                                    :class="['pr-2', {'active': currentTabIndex === vocabularies[0].idelement}]">
                                <span class="dashed-text">{{ $t('vocabulary') }}</span>
                                <a v-if="!isAndroidApp()" class="external-link ml-2" @click.stop
                                   :href="`${publicPath}lesson/${id}/tab/${vocabularies[0].idelement}`"
                                   target="_blank">
                                    <i class="fa fa-external-link-alt" :title="$t('open_in_new_tab')"></i>
                                </a>
                            </base-button>
                        </div>
                        <div class="col-auto order-lg-5 order-6" v-if="grammars.length > 0">
                            <base-button
                                    @click="currentTabIndex = grammars[0].idelement"
                                    :class="['pr-2', {'active': currentTabIndex === grammars[0].idelement}]">
                                <span class="dashed-text">{{ $t('grammar') }}</span>
                                <a v-if="!isAndroidApp()" class="external-link ml-2" @click.stop
                                   :href="`${publicPath}lesson/${id}/tab/${grammars[0].idelement}`"
                                   target="_blank">
                                    <i class="fa fa-external-link-alt" :title="$t('open_in_new_tab')"></i>
                                </a>
                            </base-button>
                        </div>
                        <div class="col-auto order-lg-6 order-7" v-if="materials.length > 0">
                            <base-button
                                    @click="currentTabIndex = materials[0].idelement"
                                    :class="['pr-2', {'active': currentTabIndex === materials[0].idelement}]">
                                <span class="dashed-text">{{ $t('materials') }}</span>
                                <a v-if="!isAndroidApp()" class="external-link ml-2" @click.stop
                                   :href="`${publicPath}lesson/${id}/tab/${materials[0].idelement}`"
                                   target="_blank">
                                    <i class="fa fa-external-link-alt" :title="$t('open_in_new_tab')"></i>
                                </a>
                            </base-button>
                        </div>
                        <div class="col-auto order-lg-7 order-8" v-if="dops.length > 0 && lesson.pos !== 1">
                            <base-button
                                    @click="currentTabIndex = dops[0].idelement"
                                    :class="['pr-2', {'active': currentTabIndex === dops[0].idelement}]">
                                <span class="dashed-text">{{ $t('dop_pack_title') }}</span>
                                <a v-if="!isAndroidApp()" class="external-link ml-2" @click.stop
                                   :href="`${publicPath}lesson/${id}/tab/${dops[0].idelement}`"
                                   target="_blank">
                                    <i class="fa fa-external-link-alt" :title="$t('open_in_new_tab')"></i>
                                </a>
                            </base-button>
                        </div>

                        <div class="col-auto order-lg-6 order-9" v-if="showGame">
                          <base-button
                              @click="currentTabIndex = gameTabIndex"
                              :class="['pr-2', {'active': currentTabIndex === gameTabIndex}]">
                            <span class="dashed-text">{{ $t('bonus_game') }}</span>
                          </base-button>
                        </div>

                        <div class="lesson-timer" v-if="timerText">
                            {{timerText}}
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="video in videos" :key="video.idelement">
                <div class="container-fluid tab-video" v-if="currentTabIndex === video.idelement">
                    <lesson-video :element="video" :points="points" :lesson="lesson" :hide-to-test="tests.length <= 0"
                                  @totests="toTests"
                                  @tolessons="toLessonsList"
                                  @timeupdate="videoTimeUpdate"
                                  @ended="videoEnded"
                                  @loadeddata="videoLoadedData"/>
                </div>
            </div>


            <div class="container-fluid tab-test" v-if="tests.length > 0 && currentTabIndex === testTabIndex">
                <div class="container">
                    <div class="row">
                        <div class="col-12">

                            <testpreview
                                    v-if="currentTestId && !showTestComplete && !showAllTestComplete"
                                    :idtest="currentTestId"
                                    :points="points"
                                    :lesson="lesson"
                                    :testsCount="tests.length"
                                    :showButtons="isAdmin"
                                    :key="currentTestId"
                                    @correctAnswer="addPoint"
                                    @wrongAnswer="wrongAnswer"
                                    @testComplete="nextTest"></testpreview>

                            <!-- <lesson-test v-if="!testsPassed && !showAllTestComplete" :tests="tests" :lesson="lesson"
                                         :points="points"
                                         @completed="allTestsPassed"
                                         @correctAnswer="addPoint"></lesson-test>

                            <lesson-match v-if="testsPassed && !showAllTestComplete && matches" :matches="matches"
                                          :lesson="lesson" :points="points"
                                          @completed="allMatchesPassed"
                                          @correctAnswer="addPoint"></lesson-match> -->

                            <div class="row mt-0 mb-8 justify-content-center" v-if="showTestComplete">
                                <div class="col text-center">

                                    <h1 class="mb-5 mt-9">{{ $t('test_complete') }}</h1>
                                    <div>{{ $t('test_points') }}:</div>
                                    <div class="col text-center birds-zerno">
                                        <div class="birds-zerno-points mx-auto">
                                            {{testpoints}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-0 mb-0 justify-content-center" v-if="showAllTestComplete">
                                <div class="col text-center">

                                    <h1 class="mb-5 mt-9">{{ lessonerrors > lessonpoints ? $t('repeat_test_later') :
                                        $t('good_all_tests_passed') }}</h1>
                                    <div>{{ $t('achieved_at_lesson') }}:</div>
                                    <div class="col text-center birds-zerno">
                                        <div class="birds-zerno-points mx-auto">
                                            {{lessonpoints}}
                                        </div>
                                    </div>
                                    <div class="mb-5 text-red">{{ $t('errors_and_omitted_tasks') }}: {{lessonerrors}}</div>

                                    <div class="col text-center" v-if="showGame" >
                                      <base-button type="secondary"
                                                   size="lg"
                                                   class="mb-2 btn-to-lessons-list"
                                                   @click="toGame">
                                        {{ $t('to_game') }}
                                      </base-button>
                                    </div>

                                    <base-button type="primary" icon="ni ni-curved-next" size="lg"
                                                 class="mb-9 btn-to-next-lesson"
                                                 @click="toMaterials">
                                        {{ $t('to_materials') }}
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="container-fluid tab-materials"
                 v-if="materials.length > 0 && currentTabIndex === materials[0].idelement">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <lesson-material v-if="materials" :materials="materials" :lesson="lesson" :points="points"
                                             :nextId="nextLessonId"
                                             @tolessons="toLessonsList"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid tab-materials"
                 v-if="vocabularies.length > 0 && currentTabIndex === vocabularies[0].idelement">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <lesson-material v-if="vocabularies" :materials="vocabularies" :lesson="lesson"
                                             :points="points"
                                             @tolessons="toLessonsList"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid tab-materials"
                 v-if="grammars.length > 0 && currentTabIndex === grammars[0].idelement">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <lesson-material v-if="grammars" :materials="grammars" :lesson="lesson" :points="points"
                                             @tolessons="toLessonsList"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid tab-materials"
                 v-if="dops.length > 0 && currentTabIndex === dops[0].idelement && lesson.pos !== 1">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <lesson-material v-if="dops" :materials="dops" :lesson="lesson" :points="points"
                                             @tolessons="toLessonsList"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid tab-materials"
                 v-if="showGame && currentTabIndex === gameTabIndex">
              <div class="container">
                <div class="row">
                  <div class="col-12">
                    <PoliJump
                    @game-over="toNextLesson"
                    @points="addPoints"/>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <modal
                :show="isOrderLockedAlert"
                @close="toLessonsList"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('lesson_unavailable_by_order') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toLessonsList">OK</base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isPerPartialPayLockedAlert"
               @close="toLessonsList"
        >
            <template v-slot:header>
              <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('lesson_per_partial_pay_locked') }}</p>
            <template v-slot:footer>
              <base-button type="primary" @click="toCoursePartialPay" :disabled="loading">{{ $t('go_to_payment') }}</base-button>
            </template>
        </modal>

        <modal
                v-if="course"
                :show="isPerDayLockedAlert"
                @close="toLessonsList"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('lesson_available_per_day') }}: <span class="strong-red">{{ course.lessons_per_day }}</span>.<br><br>
                {{ $t('lesson_will_be_available') }}
                <span v-if="course.lastCompletedLessonDate">{{ $t('through') }} <span class="strong-red">{{ course.lastCompletedLessonDate.timeToUnlock }}</span></span>
                <span v-else> {{ $t('through_24_hours') }}.</span>
            </p>
            <template v-slot:footer>
                <base-button type="primary" @click="toLessonsList">OK</base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isSubscriptionExpiredLocked"
               @close="toTimetables"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('prolong_subscription_to_access_course') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toTimetables" :disabled="loading">{{ $t('prolong') }}
                </base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="restrictedByPartialPayDebt"
               @close="toCoursePartialPay"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('locked_by_partial_pay_debt') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toCoursePartialPay" :disabled="loading">{{ $t('go_to_payment') }}
                </base-button>
            </template>
        </modal>

        <modal v-if="course && lesson"
               :show="restrictedToFreeSubscriptionAlert"
               @close="toTimetables"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('prolong_subscription_notice') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toTimetables" :disabled="loading">{{ $t('prolong') }}
                </base-button>
            </template>
        </modal>
    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<style>
    .top-select-lesson.dropdown.show ul.dropdown-menu {
        text-align: right;
        margin-top: -48px !important;
        margin-right: -20px !important;
        min-width: 17rem;
        border-radius: 10px;
    }

    .container-fluid {
        overflow: visible;
    }

    @media (max-width: 1199.98px) {
        .top-select-lesson.dropdown.show ul.dropdown-menu {
            min-width: 12rem;
            margin-left: -20px !important;
            text-align: left;
        }

        .dropdown-menu-right {
            right: auto;
        }
    }

    .lesson-blocked {
        filter: grayscale(1);
        pointer-events: none;
        user-select: none;
        opacity: 0.2;
    }
</style>

<script>
    import LessonsApi from "../data/LessonsApi";
    import {eventBus} from "../main";
    import LessonVideo from "./LessonVideo";
    import LessonMaterial from "./LessonMaterial";
    import ProgressApi from "../data/ProgressApi";
    import courseApi from "../data/CourseApi";
    import LessonNavItem from "./LessonNavItem";
    import Testpreview from "./Testpreview";
    import {hasRole, isAuthenticated} from "../data/jwt.service";
    import {androidOrderCourse, isAndroid} from "../data/AndroidApi";
    import userApi from "@/data/UserApi";
    import PoliJump from "@/views/games/PoliJump";

    export default {
        props: {
            id: {default: null},
            testId: {default: null},
            tabId: {default: null},
        },
        components: {
          PoliJump,
            LessonNavItem,
            LessonMaterial,
            LessonVideo,
            Testpreview,
        },
        data() {
            return {
                currentTabIndex: 0,
                testTabIndex: -1,
                gameTabIndex: -2,
                points: 0,

                timerSeconds: 0,
                timer: null,

                lesson: null,

                videos: [],
                materials: [],
                dops: [],

                tests: [],
                matches: [],

                grammars: [],
                vocabularies: [],

                testsPassed: false,
                matchesPassed: false,
                showAllTestComplete: false,
                showTestComplete: false,

                course: null,
                lessons: null,
                audio: new Audio(),

                progress: {
                    completedLessons: [],
                    completedCourses: [],
                    currentLesson: {
                        id: null,
                        currentTabIndex: 0,
                        currentTestId: null,
                        timerSeconds: 0
                    },
                    points: 0,
                },

                currentTestId: null,
                currentTestNumber: 0,
                testpoints: 0,
                testerrors: 0,
                lessonpoints: 0,
                lessonerrors: 0,

                isAdmin: false,

                lessonsIds: [],

                videoTime: null,
                player: null,

                isOrderLockedAlert: false,
                isPerDayLockedAlert: false,
                isPerPartialPayLockedAlert: false,
                isSubscriptionExpiredLocked: false,
                restrictedByPartialPayDebt: false,
                restrictedToFreeSubscriptionAlert: false,

                loading: false,

            };
        },
        methods: {

            allTestsPassed() {
                this.testsPassed = true
                this.showAllTestComplete = true
                this.completeLesson()

            },

            toTests() {
                this.currentTabIndex = this.testTabIndex
            },

            toMaterials() {
                this.currentTabIndex = this.materials[0].idelement
            },

            toDops() {
                this.currentTabIndex = this.dops[0].idelement
            },

            toGame() {
                this.currentTabIndex = this.gameTabIndex
            },

            toNextLesson() {
              this.$router.push('/lesson/' + this.nextLessonId)
            },

            addPoints(score) {
              //if (isAuthenticated()) ProgressApi.addPoints(1)
            },

            startTimer() {
                this.timer = setInterval(() => {
                    this.timerSeconds++
                }, 1000)
            },

            stopTimer() {
                clearTimeout(this.timer)
            },

            addPoint() {
                this.points++;
                this.testpoints++
                this.lessonpoints++
                if (isAuthenticated()) ProgressApi.addPoints(1)
            },

            wrongAnswer(params) {
                this.testerrors++
                this.lessonerrors++
                console.log(params)
            },

            async nextTest(params) {
                this.showTestComplete = true
                const test = this.tests[this.currentTestNumber]
                const testFailed = this.testerrors > this.testpoints
                let audio_url = ''

                if (testFailed) {
                    audio_url = (test.fl_fail_audio == 1) ? require('@/assets/audio/try_again_later.mp3') : test.fail_audio
                } else {
                    if (test.fl_end_audio) {
                        audio_url = this.getRandomItem([
                            require('@/assets/audio/wonderful.mp3'),
                            require('@/assets/audio/well_done.mp3'),
                            require('@/assets/audio/very_well.mp3'),
                            require('@/assets/audio/great.mp3'),
                        ])
                    } else {
                        audio_url = test.end_audio
                    }
                }

                await this.play(audio_url)
                await this.sleep(audio_url ? 1000 : 2000)

                this.testerrors = 0
                this.testpoints = 0
                this.showTestComplete = false

                console.log('nextTest')
                if (this.tests && this.tests.length > this.currentTestNumber + 1) {
                    this.currentTestNumber++;
                    this.currentTestId = this.tests[this.currentTestNumber].idtest
                } else {
                    this.allTestsPassed()
                }
            },

            getRandomItem(items) {
                return items[Math.floor(Math.random() * items.length)]
            },

            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился' + path)
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            videoTimeUpdate(player) {
                if (player.currentTime() > 0) {
                    this.videoTime = player.currentTime()
                }
            },

            videoEnded(player) {
                //10 зерен за просмотр видео пользователем до конца
                if (isAuthenticated()) ProgressApi.addPoints(10)
            },

            videoLoadedData(player) {
                this.player = player
                if (Math.round(this.player.currentTime()) !== Math.round(this.videoTime)) {
                    player.currentTime(this.videoTime)
                }
            },

            saveProgress() {
                if (isAuthenticated() && this.timerSeconds > 0) {
                    ProgressApi.saveProgress(
                        this.id,
                        this.currentTabIndex === this.gameTabIndex ?  this.testTabIndex : this.currentTabIndex,
                        null,
                        this.timerSeconds,
                        this.videoTime)
                }
            },

            completeLesson() {
                if (isAuthenticated()) ProgressApi.completeLesson(this.id, this.timerSeconds)
            },

            pad(num, size) {
                var s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },

            getColor(lesson) {
                if (lesson.isCompleted) return 'green'
                if (this.id == lesson.idlesson) return 'orange'
                //if (this.progress.completedLessons.filter(i => i == lesson.idlesson).length > 0) return 'green'
                return 'gray'
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

            toLessonsList() {
                this.isOrderLockedAlert = false
                this.isPerDayLockedAlert = false
                this.isPerPartialPayLockedAlert = false
                this.isSubscriptionExpiredLocked = false
                this.restrictedByPartialPayDebt = false
                this.restrictedToFreeSubscriptionAlert = false
                document.body.classList.remove("modal-open");
                this.$router.push('/course/' + this.course.slug)
            },

            toTimetables() {
                this.isOrderLockedAlert = false
                this.isPerDayLockedAlert = false
                this.isPerPartialPayLockedAlert = false
                this.isSubscriptionExpiredLocked = false
                this.restrictedByPartialPayDebt = false
                this.restrictedToFreeSubscriptionAlert = false
                document.body.classList.remove("modal-open");
                this.$router.push('/user/profile/timetables')
            },


            toCoursePartialPay() {
                this.isOrderLockedAlert = false
                this.isPerDayLockedAlert = false
                this.isPerPartialPayLockedAlert = false
                this.isSubscriptionExpiredLocked = false
                this.restrictedByPartialPayDebt = false
                this.restrictedToFreeSubscriptionAlert = false
                document.body.classList.remove("modal-open");
                let params = ['partial']
                this.$router.push('/payment/' + this.course.idcourse + (params.length ? ('?' + params.join('&')) : ''))
            },

            isAndroidApp() {
                return isAndroid()
            },
        },

        computed: {
            timerText() {
                const sec = this.timerSeconds % 60
                const min = Math.trunc(this.timerSeconds / 60)
                return this.pad(min, 2) + ':' + this.pad(sec, 2)
            },

            nextLessonId() {
                if (this.lesson && this.lessonsIds && this.lessonsIds.length > 0) {
                    let index = this.lessonsIds.map(e => e.idlesson).indexOf(this.lesson.idlesson);
                    console.log(index)
                    index++;
                    if (index < this.lessonsIds.length) return this.lessonsIds[index].idlesson
                }
                return null
            },

            publicPath() {
                return process.env.VUE_APP_PUBLIC_PATH
            },

            showGame() {
              return this.showAllTestComplete
            }
        },

        watch: {
            timerSeconds(time) {
                //сохраняем прогрес раз в 10 секунд
                if (time % 10 === 0 && time >= 10) {
                    this.saveProgress()
                }
            },
            currentTabIndex() {
                console.log("currentTabIndex=" + this.currentTabIndex)
                if (!this.tabId)
                    this.saveProgress()
            },
        },

        mounted() {
            this.isAdmin = hasRole('Admin')
            LessonsApi.fetchLesson(this.id)
                .then(response => {
                    this.lesson = response
                    courseApi.fetchCourse(this.lesson.idcourse)
                        .then(response => {
                            this.course = response
                            if (isAuthenticated() && this.lesson.isfree && !this.course.ordered)
                                userApi.trackEvent('view_free_course_lesson', 'course_id_' + this.lesson.idcourse)
                            LessonsApi.fetchLessons(this.course.idcourse)
                                .then(response => {
                                    this.lessons = response
                                })
                                .catch(error => {
                                    let data = error.response.data
                                    this.error = this.pretty(data)
                                    this.loading = false
                                })

                            LessonsApi.fetchElements(this.id)
                                .then(response => {
                                    let data = response
                                    data.forEach(element => {
                                        if (element.idelementtype === 'video') {
                                            this.videos.push(element)
                                        }
                                        if (element.idelementtype === 'materials') {
                                            this.materials.push(element)
                                        }
                                        if (element.idelementtype === 'vocabulary') {
                                            this.vocabularies.push(element)
                                        }
                                        if (element.idelementtype === 'grammar') {
                                            this.grammars.push(element)
                                        }
                                        if (this.course.isAdditionalPackage && element.idelementtype === 'addpack') {
                                            this.dops.push(element)
                                        }
                                        if (this.tabId) {
                                            this.currentTabIndex = Number.parseInt(this.tabId)
                                        } else if (this.currentTabIndex === 0 && this.videos.length > 0) {
                                            this.currentTabIndex = this.videos[0].idelement
                                        } else if (this.currentTabIndex === 0 && this.videos.length === 0) {
                                            this.currentTabIndex = this.testTabIndex
                                        }
                                    })
                                })
                                .catch(error => {
                                    if (error.response.status === 403) {
                                        this.$router.push('/order/' + this.lesson.idcourse)
                                    }
                                    let data = error.response.data
                                    this.error = this.pretty(data)
                                    this.loading = false
                                })

                            if (this.testId) {
                                if (!hasRole('Admin')) this.$router.push('/lesson/' + this.id)
                                LessonsApi.fetchTest(this.testId)
                                    .then(response => {
                                        this.tests = [response]
                                        this.currentTabIndex = this.testTabIndex
                                        if (this.tests && this.tests.length > 0) {
                                            this.currentTestId = this.tests[this.currentTestNumber].idtest
                                        }
                                    })
                                    .catch(error => {
                                        let data = error.response.data
                                        this.error = this.pretty(data)
                                        this.loading = false
                                    })
                            } else {
                                LessonsApi.fetchTests(this.id)
                                    .then(response => {
                                        this.tests = response
                                        if (this.tests && this.tests.length > 0) {
                                            this.currentTestId = this.tests[this.currentTestNumber].idtest
                                        }
                                    })
                                    .catch(error => {
                                        if (error.response.status === 403) {
                                            this.$router.push('/order/' + this.lesson.idcourse)
                                        }
                                        let data = error.response.data
                                        this.error = this.pretty(data)
                                        this.loading = false
                                    })
                            }

                            eventBus.$emit('setNavBarTitle', this.lesson.lesson);
                            document.title = this.lesson.lesson

                            if (!this.lesson.isLocked
                                && !this.course.restrictedByExpiredSubscription
                                && !this.course.restrictedToFreeSubscription
                                && !this.course.restrictedByPartialPayDebt) {
                                // this.progress = ProgressApi.fetchProgress()
                                if (isAuthenticated()) {
                                    ProgressApi.fetchProgress()
                                        .then(progress => {
                                            this.progress = progress;
                                            this.points = progress.points;
                                            ProgressApi.fetchLessonProgress(this.id)
                                                .then(lessonProgress => {
                                                    console.log("lessonProgress", lessonProgress)
                                                    this.timerSeconds = lessonProgress.timerSeconds;
                                                    this.videoTime = lessonProgress.videoTime;
                                                    console.log("this.videoTime", this.videoTime)
                                                    if (this.player) {
                                                        this.player.currentTime(this.videoTime)
                                                    }
                                                    if (lessonProgress.currentTabIndex !== 0 && !this.tabId) {
                                                        this.currentTabIndex = lessonProgress.currentTabIndex;
                                                    }
                                                })
                                        })
                                        .finally(() => {
                                            this.startTimer();
                                            //this.saveProgress();
                                        });
                                }


                                LessonsApi.fetchLessonsIds(this.lesson.idcourse)
                                    .then(response => {
                                        this.lessonsIds = response
                                    })
                                    .catch(error => {
                                        let data = error.response.data
                                        this.error = this.pretty(data)
                                        this.loading = false
                                    })
                            } else {
                                if (this.course.restrictedByExpiredSubscription) {
                                    this.isSubscriptionExpiredLocked = true
                                    androidOrderCourse(this.course.idcourse)
                                } else if (this.course.restrictedByPartialPayDebt) {
                                    this.restrictedByPartialPayDebt = true
                                    androidOrderCourse(this.course.idcourse)
                                } else if (!this.lesson.isfree && this.course.restrictedToFreeSubscription) {
                                    this.restrictedToFreeSubscriptionAlert = true
                                    androidOrderCourse(this.course.idcourse)
                                } else if (this.lesson.isOrderLocked) {
                                    this.isOrderLockedAlert = true
                                } else if (this.lesson.isPerDayLocked) {
                                    this.isPerDayLockedAlert = true
                                } else if (this.lesson.isPerPartialPayLocked) {
                                    this.isPerPartialPayLockedAlert = true
                                }
                            }

                        })
                        .catch(error => {
                            let data = error.response.data
                            this.error = this.pretty(data)
                            this.loading = false
                        })

                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        destroyed() {
            this.isOrderLockedAlert = false
            this.isPerDayLockedAlert = false
            this.isPerPartialPayLockedAlert = false
            this.isSubscriptionExpiredLocked = false
            this.restrictedByPartialPayDebt = false
            this.restrictedToFreeSubscriptionAlert = false
            document.body.classList.remove("modal-open");
            this.stopTimer()
        },
    };
</script>
<style>
    .strong-red {
        font-family: Manrope Bold;
        color: #ed1c24;
    }
</style>
